import {
  Button,
  ButtonGroup,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import {
  NotificationGroup,
  useMarkAllNotificationsAsReadMutation,
} from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { observer } from "mobx-react-lite";
import type { FC } from "react";

export const TaskNotificationsSettings: FC<{
  notificationCount?: number;
  showRead: boolean;
  onShowReadChanged: (checked: boolean) => void;
  onMark: () => void;
  isLoading: boolean;
}> = observer(function TaskNotificationsSettings({
  notificationCount,
  showRead,
  onShowReadChanged,
  onMark,
  isLoading,
}) {
  const [{ fetching: marking }, markAll] =
    useMarkAllNotificationsAsReadMutation();

  return (
    <HStack spacing="2">
      <ButtonGroup size="xs" spacing="0">
        <Button
          isLoading={isLoading}
          onClick={() => {
            onShowReadChanged(true);
          }}
          roundedRight="none"
          variant={showRead ? "solid" : "outline"}
        >
          <Trans>All</Trans>
        </Button>
        <Button
          isLoading={isLoading}
          onClick={() => {
            onShowReadChanged(false);
          }}
          roundedLeft="none"
          variant={showRead ? "outline" : "solid"}
        >
          <Trans>Unread</Trans>
        </Button>
      </ButtonGroup>
      <Menu>
        <MenuButton>
          {marking ? (
            <Spinner color="teal.500" size="xs" />
          ) : (
            <Icon name="dots-horizontal" />
          )}
        </MenuButton>
        <MenuList zIndex="31">
          {Boolean(notificationCount) && (
            <MenuItem
              onClick={() => {
                markAll({
                  groups: [NotificationGroup.TaskCommunication],
                }).then(onMark);
              }}
            >
              <Text fontSize="md">
                <Trans>Mark all as read</Trans>
              </Text>
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </HStack>
  );
});
